import axios from "axios";

let isFavoritesPage = document.querySelector(".page-favorites") !== null;

var favorites = {
  init: function() {
    // Add / remove favorite
    var $addBtns = document.querySelectorAll(".js-add-favorite");
    var $removeBtns = document.querySelectorAll(".js-remove-favorite");

    if ($addBtns.length > 0) {
      $addBtns.forEach(($btn) => {
        $btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.add($btn);
        });
      });
    }
    if ($removeBtns.length > 0) {
      $removeBtns.forEach(($btn) => {
        $btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.remove($btn);
        });
      });
    }
  },

  add: function(btn) {
    axios
      .post("/umbraco/surface/favorite/add", { productId: btn.dataset.itemId })
      .then((response) => {
        if (response.status === 200) {
          this.toggle(btn);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },

  remove: function(btn) {
    axios
      .post("/umbraco/surface/favorite/remove", {
        productId: btn.dataset.itemId
      })
      .then((response) => {
        if (response.status === 200) {
          if (isFavoritesPage) {
            btn.closest(".variants__row").remove();
            if (document.querySelectorAll(".variants__row").length === 1) {
              document
                .querySelector(".js-favorite-list")
                .classList.add("d-none");
              document
                .querySelector(".js-favorite-empty")
                .classList.remove("d-none");
            }
          } else {
            this.toggle(btn);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },

  toggle: function(btn) {
    let $parent = btn.parentNode;
    let $btns = $parent.querySelectorAll("a");
    $btns.forEach(($btn) => $btn.classList.toggle("d-none"));
  }
};

export default favorites;
